import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import PersonIcon from "assets/icons/person.svg?react";
import tagsService from "api/tagsService";
import { ITag, TagType } from "dto/ITag";
import Input from "components/Input";
import TagBadge from "components/TagBadge";
import { useTranslation } from "react-i18next";

const RolesTab = () => {
  const { t } = useTranslation();
  const { mutate: addTag } = tagsService.useCreateTag();
  const { mutate: removeTag } = tagsService.useDeleteTag();
  const { mutate: editTag } = tagsService.useEditTag();

  const { data: tagsData, refetch: refetchTags } = tagsService.useGetTags(
    false,
    TagType.Participants
  );

  const [tags, setTags] = useState<ITag[]>([]);

  const [tagValue, setTagValue] = useState<string>();

  const handleTagChange = (text: string) => setTagValue(text);

  const handleRemoveTag = (tag: ITag) => {
    removeTag(
      {
        Id: tag.Id,
      },
      {
        onSuccess: () => {
          refetchTags();
        },
      }
    );
  };

  const createNewTag = (tag: ITag) => {
    addTag(
      {
        Name: tag.Name,
        Type: TagType.Participants,
      },
      {
        onSuccess: () => refetchTags(),
      }
    );
  };

  const handleEditTag = (tag: ITag) => {
    editTag(
      {
        Id: tag.Id,
        Name: tag.Name,
      },
      {
        onSuccess: () => {
          refetchTags();
        },
      }
    );
  };

  useEffect(() => {
    if (!tagsData?.data) return;
    setTags(tagsData?.data);
  }, [tagsData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.group}>
        <div className={styles.title}>
          <PersonIcon></PersonIcon>{t("roles.title")}
        </div>
        <div className={styles.hint}>
          {t("settings.rolesDescription")}
        </div>
      </div>
      <div className={styles.group}>
        <Input
          type="text"
          onChange={handleTagChange}
          onAccept={() => {
            if (!tagValue) return;
            createNewTag({
              Id: "",
              Name: tagValue ?? "",
              Type: 0,
              Flags: 0,
              Global: true,
            });
            setTagValue("");
          }}
          onRightText={t("common.save")}
          onRightClick={() => {
            if (!tagValue) return;
            createNewTag({
              Id: "",
              Name: tagValue ?? "",
              Type: 0,
              Flags: 0,
              Global: true,
            });
            setTagValue("");
          }}
          label={t("forms.role")}
          value={tagValue}
          hideTags
        ></Input>

        {tags && (
          <div className={styles.tags}>
            {tags
              .filter((t) => !t.WorkspaceId)
              .map((tag) => (
                <TagBadge
                  key={tag.Id}
                  onEdit={!tag.Global ? handleEditTag : undefined}
                  onRemove={
                    !tag.Global ? (tag) => handleRemoveTag(tag) : undefined
                  }
                  tag={tag}
                />
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RolesTab;
